export * from './add-fixed-assests/add-fixed-assests.component';
export * from './fixed-assets.component';
export * from './fixed-assets-overview/fixed-assets-overview.component';
export * from './fixed-assets-overview/assets-count-chart/assets-count-chart.component';
